import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { initSentry, ErrorBoundary } from './config/sentry.js'
import App from './App.jsx'
import './index.css'
import './styles/notificacoes.css';

// ==========================================
// SENTRY - INICIALIZAÇÃO
// ==========================================
initSentry();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <ErrorBoundary
        fallback={({ error, componentStack, resetError }) => (
          <div style={{ padding: '2rem', textAlign: 'center' }}>
            <h2>Algo deu errado!</h2>
            <p style={{ color: '#ef4444', margin: '1rem 0' }}>
              {error?.message || 'Erro desconhecido'}
            </p>
            <button
              onClick={resetError}
              style={{
                padding: '0.5rem 1rem',
                background: '#3b82f6',
                color: 'white',
                border: 'none',
                borderRadius: '0.25rem',
                cursor: 'pointer',
              }}
            >
              Tentar novamente
            </button>
          </div>
        )}
        onError={(error, componentStack) => {
          console.error('Erro capturado pelo ErrorBoundary:', error);
        }}
      >
        <App />
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: '#10b981',
                secondary: '#fff',
              },
            },
            error: {
              duration: 4000,
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fff',
              },
            },
          }}
        />
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>,
)
